import { render, staticRenderFns } from "./templateAdmin.vue?vue&type=template&id=d707b984&scoped=true&"
import script from "./templateAdmin.vue?vue&type=script&lang=js&"
export * from "./templateAdmin.vue?vue&type=script&lang=js&"
import style0 from "./templateAdmin.vue?vue&type=style&index=0&id=d707b984&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d707b984",
  null
  
)

export default component.exports